<template lang="pug">
div
  b-card(v-if="!loaded")
    .d-flex.justify-content-center
      h1 Loading Data
    .d-flex.justify-content-center
      b-spinner(label="Loading")
  b-card(v-else)
    template(#header)
      .d-flex
        b-button.ml-auto(@click="saveChanges") Save Changes
    h1 Exam Scheduler
    b-tabs(v-model="$root.tab")
      b-tab.p-3(title="Upload Student List")
        h3 Upload Student list from master XLSX file
        b-form-file(@input="processXLSX")
        b-alert(show v-if="students.length > 0" variant="success") Student Data Loaded, {{students.length}} students found.
        hr
        b-button(@click="resetData(true)").mr-1 Reset Data
        b-button(@click="resetStudents()") Reset Students
      b-tab.p-3(title="Base Configuration")
        .p-3
          h3 Exam Dates
          .d-flex
            b-form-group.mr-3()
              h5 Start
              b-input(type="date" v-model="start")
            b-form-group()
              h5 End
              b-input(type="date" v-model="end")
          
          b-form-group()
            h5 Working Days
            b-checkbox-group(buttons button-variant="outline-primary" v-model="assignableDays" :options="[{value:0,text:'Su'},{value:1,text:'M'},{value:2,text:'Tu'},{value:3,text:'W'},{value:4,text:'Th'},{value:5,text:'F'},{value:6,text:'Sa'}]")
          b-form-group()
            h5 Session time
            b-input-group.border-bottom.mb-1.pb-1(prepend="No of Sessions" style="max-width:600px;")
              b-input(v-model="noOfSessions" type="number" min="0")
            
            .d-flex(style="max-width:600px;" v-for="(session,sessionNo) in timeStartEndArr")
              b-input-group(:prepend="'Session '+(sessionNo+1)+' Start'")
                b-input(v-model="session[0]" type="time")
              b-input-group(:prepend="'Session '+(sessionNo+1)+' End'")
                b-input(v-model="session[1]" type="time")
          b-form-group()
            h5 Off Days
            .d-flex(v-for="(off,i) of offDays" :key="'off'+i" style="max-width:400px;")
              b-input(type="date"   v-model="offDays[i]"  @blur="trimOffInput(offDays,i)" size="sm")
              b-button(@click="trimOffInput(offDays,i,true)" size="sm")
                b-icon(icon="trash")
            b-button.mt-3(@click="addOff(offDays)" size="sm") Add off day
        hr

        .bg-light.p-3
          h4 Exam Rooms
          .d-flex.align-items-stretch.flex-wrap
            div.border.p-2(v-for="(room,i) of rooms" style="min-width:400px;")
              h5 Room Name
              b-input.mb-3(v-model="room.name")
              h6 Unavailable Days
              p(v-if="room.exclude.length <1") N/A
              .d-flex(v-for="(off,j) of room.exclude" :key="'examroom-'+i+'-'+j" style="max-width:400px;")
                b-input(type="date"   v-model="room.exclude[j]" size="sm")
                b-button(@click="trimOffInput(room.exclude,j,true)" size="sm")
                  b-icon(icon="trash")
              .d-flex
                b-button.mt-3(@click="addOff(room.exclude)" size="sm") Add unavailable day
                b-button.mt-3.ml-auto(@click="trimOffInput(rooms,i,true)" size="sm" variant="danger") Remove Room

          b-button.mt-3(@click="addRoom" size="sm") Add Room
        hr
        .p-3
          h4 Examiners
          .d-flex.align-items-stretch.flex-wrap
            div.border.p-2(v-for="(examiner,i) of examiners" style="min-width:400px;")
              h5 Examiner Name
              b-input.mb-3(v-model="examiner.name")
              h6 Instruments - Max Grade - Min Grade
              .d-flex(v-for="(inst,j) of examiner.instruments" :key="'examiner-'+i+'-'+j" style="max-width:400px;")
                b-select(v-model="examiner.instruments[j]" size="sm" :options="instrumentDropDown" style="max-width:200px")
                b-select(v-model="examiner.instrumentLevelLimit[j]" size="sm" :options="instrumentGradeDropDown" style="max-width:100px")
                b-select(v-model="examiner.instrumentLevelLowerLimit[j]" size="sm" :options="instrumentGradeDropDown" style="max-width:100px")
                b-button(@click="trimOffInput(examiner.instruments,j,true)" size="sm")
                  b-icon(icon="trash")
              b-button.my-3(@click="addOff(examiner.instruments,examiner.instrumentLevelLimit,8,examiner.instrumentLevelLowerLimit,0)" size="sm" block) Add Instrument
              h6 Unavailable Days
              p(v-if="examiner.exclude.length <1") N/A
              .d-flex(v-for="(off,j) of examiner.exclude" :key="'examineroff-'+i+'-'+j" style="max-width:400px;")
                b-input(type="date"   v-model="examiner.exclude[j]" size="sm")
                b-button(@click="trimOffInput(examiner.exclude,j,true)" size="sm")
                  b-icon(icon="trash")
              .d-flex
                b-button.mt-3(@click="addOff(examiner.exclude)" size="sm") Add unavailable day
                b-button.mt-3.ml-auto(@click="trimOffInput(examiners,i,true)" size="sm" variant="danger") Remove Examiner

          b-button.mt-3(@click="addExaminer" size="sm") Add Examiner
        hr
        .bg-light.p-3
          h4 Exam Duration (In minutes)
          //div.mb-1
            b-button(size="sm" variant="outline-primary") Download CSV template to edit
            b-button.ml-1(size="sm" variant="outline-primary") Upload CSV template to save
          b-table-simple(small)
            b-thead
              b-tr
                b-th Instrument
                b-th(v-for="grade of grades") {{grade}}
            b-tbody
              b-tr(v-for="(inst,i) of instruments")
                b-th {{inst}}
                b-td(v-for="(grade,j) of grades") 
                  b-input(type="number" v-model="duration[i][j]" number)
      b-tab.p-3(title="Setup Rooms")
        b-modal(v-model="reassignModal" :title="reassignModalTitle" ok-only)
          b-form-group(label="Assigned to")
            b-select(size="sm" v-model="reassignModalRoom")
              b-select-option(v-for="room of rooms" :value="room.id" :disabled="getRoomAssignmentInfo(reassignModalData.roomAssignment,room.id).not_in_use") {{room.name}}
              b-select-option(value="unassigned") Unassigned
              b-select-option(value="unavailable") Unavailable
          hr
          h6 Examiner is qualified for the following:
          b-table-simple(small)
            b-thead
              b-tr
                b-th Instrument
                b-th Level
            b-tbody
              b-tr(v-for="(inst,j) of getExaminer(reassignModalData.examiner).instruments" :key="'examinst-'+j" style="max-width:400px;")
                b-td {{instruments[getExaminer(reassignModalData.examiner).instruments[j]]}}
                b-td {{grades[getExaminer(reassignModalData.examiner).instrumentLevelLimit[j]]}}
              
        b-modal(v-model="roomModal" :title="roomModalTitle" ok-only)
          b-form-group(label="Room Availability")
            b-checkbox(v-model="roomModalUnavailable") Room is not available

        p.lead Assign Examiners to Rooms by Day
        b-alert(show)
          p.mb-1 Once assigned, click on the name to see details of each examiner or reassign them.
          p.mb-1 You can also click on rooms with no examiners assigned to set them as unavailable 
          p.mb-1 You will need to manually assign 2 instructors to a room to allow CIPP students to take their exam.
          p.mb-0 Note that you should rerun the "Assign Exam Slots" function one more time if you modify this page.
          
        .d-flex.mb-1
          b-button(@click="runRoomAssignment" size="sm" variant="primary") Run Assignment
          b-input-group.ml-1(style="max-width:250px")
            b-input(type="date" size="" v-model="addRADate")
            b-input-group-append
              b-button(size="sm" @click="addRoomAssignment") Add Date
          hr
        b-table-simple(small)
          b-thead
            b-tr
              b-th Day
              b-th(v-for="room of rooms" :key="'room-'+room.id") {{room.name}}
              b-th Unassigned
              b-th Unavailable
            
          b-tbody
            b-tr(v-for="(ra,raDex) of roomAssignmentSorted")
              b-th 
                p.mb-1 {{dayjs(ra.date).format("ddd, DD MMM YYYY ")}}
                b-form-group()
                  .d-flex(style="max-width:600px;" v-for="(session,sessionNo) in ra.timeStartEndArr")
                    b-input-group(:prepend="'Session '+(sessionNo+1)+' Start'" size="sm")
                      b-input(v-model="session[0]" type="time")
                    b-input-group(:prepend="'Session '+(sessionNo+1)+' End'" size="sm")
                      b-input(v-model="session[1]" type="time")

                b-button(size="sm" @click="removeRoomAssignment(ra.id)" variant="outline-danger") Remove Date
              b-td(v-for="room of rooms" :key="'roomass-'+room.id") 
                p(v-for="ex_id of getRoomAssignmentInfo(ra,room.id).examiner") 
                  a(@click.prevent="reassignExaminer(ra.id,ex_id)" href="#")  {{getExaminer(ex_id).name}}
                p(v-if="getRoomAssignmentInfo(ra,room.id).not_in_use") 
                  a.text-danger(@click.prevent="adjustRoom(ra.id,room.id)" href="#") Not Available
                p(v-else-if="getRoomAssignmentInfo(ra,room.id).examiner.length <1") 
                  a.text-warning(@click.prevent="adjustRoom(ra.id,room.id)" href="#") No Examiner Assigned

              b-td
                p(v-for="ex_id of ra.unassigned")  
                  a.text-muted(@click.prevent="reassignExaminer(ra.id,ex_id)" href="#") {{getExaminer(ex_id).name}}
              b-td
                p.text-danger(v-for="ex_id of ra.unavailable")
                  a.text-danger(@click.prevent="reassignExaminer(ra.id,ex_id)" href="#") {{getExaminer(ex_id).name}}
      b-tab.p-3(title="Assign Exam Slots")
        h4 Summary of Assignments
        b-table(:items="instGradeMatrix" :fields="instGradeFields" striped small sticky-header="650px" responsive)
        p.small Note: Running Assignment will discard any existing assignment. CIPP will not be assigned unless you have allocated more than one instructor to a room. {{cippfirst?"CIPP will be assigned first, followed by higher grades. Lower grades will be assigned last":"Lower grades will be assigned first, with CIPP assigned last"}}
        b-checkbox.mb-2(switch v-model="cippfirst") Assign CIPP &amp; higher grades first.
        b-button.mr-1(@click="autoAssign()") Run Auto Assignment

        hr
        h4 Assignment Details
        b-form-group(label="Date" style="max-width:450px;")
          b-select(:options="assignmentDateDropdown" v-model="viewDate")
        .d-flex
          b-button.mr-1(@click="exportXLSX()") Export Assignment by Date
          b-button(@click="exportXLSX(true)") Export Assignment by Examiner
        hr


        b-table(:items="assignmentTableData" :fields="assignmentTableFields" sort-by="startTime" small ref="exportTable")
          template(#cell(examiners)="{value}")
            ul
              li(v-for="ex_id of value") {{getExaminer(ex_id).name}}
      b-tab.p-3(title="Send Notifications")
        Notif(v-if="$root.tab==4" :start="start")
</template>

<script>
import Notif from "./Notif.vue"
import Dexie from 'dexie';
var db = new Dexie("teng_exam_scheduling");
db.version(1).stores({
    options: "&key",
});

import { grades, instruments } from "./config.js";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
import customParseFormat from "dayjs/plugin/customParseFormat"
dayjs.extend(customParseFormat);
import { v4 } from "uuid";
const rndArr = (arr) => Math.floor(Math.random() * arr.length);
import rndName from "chinese-random-name/random.min";
import XLSX from "xlsx"

export default {
  name: "App",
  components:{Notif},
  data() {
    let newState = this.resetData();
    return newState;
    

    
  },
  async mounted() {
    let store = await db.options.get({key:"state"});

    try{
      let state = store ? JSON.parse(store.value) : {} ;
      for(let key in state){
        this[key] = state[key];
      }

    }catch(err){
      console.log(err);
      alert("Corrupted data in store.")
    }

    this.generateDuration();
    this.loaded = true;
  },
  methods: {
    async saveChanges(){
      await db.options.put({
        key:"state",
        value:JSON.stringify(this.$data)
      })
      alert("Changes Saved");
    },
    resetData(execute){
      let dateStart = dayjs().month(10).endOf("Month").startOf("week").add(1,"day")
      let dateEnd = dateStart.add(1,"weeks").day(5);

      let newState = {
        excelHeaders:[],
        todo: false,
        loaded: false,
        grades: grades.slice(),
        instruments: instruments.slice(),
        start: dateStart.format("YYYY-MM-DD"),
        end: dateEnd.format("YYYY-MM-DD"),
        offDays: [""],
        assignableDays: [1, 2, 3, 4, 5],
        noOfSessions:4,
        timeStartEndArr: [["09:30", "10:45"],["11:00", "12:30"],["14:00","15:45"],["16:00","18:00"]],
        
        viewDate: null,
        rooms: [
          { id: v4(), name: "SR 803", exclude: [] },
          { id: v4(), name: "SR 804", exclude: [] },
          { id: v4(), name: "SR 703", exclude: [] },
          { id: v4(), name: "SR 706", exclude: [] },
          { id: v4(), name: "SR 708", exclude: [] },
        ],
        //max grade GRADE?
        //CIMGE definitions
        //cipp need to double up examiner (move from one room to another)
        examiners: [
        ],
        duration: [],
        students: [],
        byInstrument: false,
        roomAssignment: [],
        roomSlots: [],
        roomModal: false,
        roomModalData: {
          roomAssignment: null,
          room_id: null,
        },
        reassignModal: false,
        reassignModalData: {
          roomAssignment: null,
          examiner: null,
        },
        addRADate: "",
        cippfirst:false,
      };

      if(execute){
        db.options.delete("state").then(()=>{
          window.location.reload();
        })
        
      }
      return newState
    },
    resetStudents(){
      this.roomSlots = []; //reset all Data;
      for(let student of this.students){
        student.assignment = null;
      }
      this.students = [];

    },
    async processXLSX(file){
        let arrB = await file.arrayBuffer();
        let wb = XLSX.read(arrB);
        let ws = wb.Sheets[wb.SheetNames[0]];
        var arr = XLSX.utils.sheet_to_json(ws,{header:1});
        this.excelHeaders = arr[0]
        let headers = {
          name:arr[0].findIndex((v)=>v=="Full Name"),
          grade:arr[0].findIndex((v)=>v=="Grade"),
          instrument:arr[0].findIndex((v)=>v=="Instrument Type")
        }
        for(let i=0; i < arr.length; i++){
          let rawdata = arr[i]

          if(i===0){    
            continue;
          }

          let id = v4();
          let name = rawdata[headers.name];
          let grade= grades.findIndex(row=>row.toLowerCase()==rawdata[headers.grade].toLowerCase());
          let instrument= instruments.findIndex(row=>row.toLowerCase()==rawdata[headers.instrument].toLowerCase());
          let assignment= null;
          
          if(instrument ===-1 ){
            console.log(rawdata[headers.instrument]);
            alert(`${rawdata[headers.instrument]} is not a valid instrument. Check the excel import and fix any typos. Skipping student ${name}`);
            continue;
          }
          if(grade ===-1 ){
            console.log(rawdata[headers.grade]);
            alert(`${rawdata[headers.grade]} is not a valid grade. Check the excel import and fix any typos. . Skipping student ${name}`);

            continue;
          }

          this.students.push({
            id,name,grade,instrument,assignment,rawdata
          })
        }
        alert("Data Imported!");

    },
    exportXLSX(examiner){
      if(!examiner){
        return this.exportXLSXDates();
      }
      return this.exportXLSXExaminer();

    },
    async exportXLSXDates(){
      let dates  = this.assignmentDateDropdown.map(o=>o.value).filter(v=>!!v);
      var wb = XLSX.utils.book_new();
      for(let date of dates){
          let dateData = this.listViewDate(date);
          
          let aoa = this.exportXLSXaoa(dateData);
          let ws = XLSX.utils.aoa_to_sheet(aoa, {dense:true});
          ws['!cols']= this.exportXLSXautowidth(aoa);
          XLSX.utils.book_append_sheet(wb, ws, date);
      }
      XLSX.writeFile(wb, "exportedSchedule.xlsx");

    },
    async exportXLSXExaminer(){
      let examiners  = ["Unassigned Students",...this.examiners.map(ex=>ex.id)]
      var wb = XLSX.utils.book_new();
      for(let examiner of examiners){
          let sheetName = examiner == "Unassigned Students" ? "Unassigned Students" : this.getExaminer(examiner).name;
          let exData = this.listViewExaminer(examiner);
          let aoa = this.exportXLSXaoa(exData);
          let ws = XLSX.utils.aoa_to_sheet(aoa, {dense:true});
          ws['!cols']= this.exportXLSXautowidth(aoa);
          XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }
      XLSX.writeFile(wb, "exportedSchedule.xlsx");

    },
    exportXLSXaoa(data){
      let spliceOut = this.excelHeaders.findIndex(str=>str=="Full Name");
      let headers = this.excelHeaders.slice()
      headers.splice(spliceOut,1);
      return [[
            "Candidate Number",
            "Date",
            "Full Name",
            "Room Name",
            "Reporting Time",
            "Start Time",
            "End Time",
            "Instrument",
            "Grade",
            "Examiners",
            ...headers,
          ],...data.map(rs=>{
            let output = ["",rs.date];
            for(let def of this.assignmentTableFields){
              let raw = rs[def.key];
              if(raw === undefined && !def.formatter){
                output.push("");
                continue;
              }
              if(def.key == "examiners"){
                output.push(raw.map(ex_id=>this.getExaminer(ex_id).name).join("\n"));
                continue;
              }
              if(def.formatter){
                output.push(def.formatter(raw,def.key,rs));
                continue;
              }
              output.push(raw);
            }
            console.log(rs.rawdata.slice())
            let otherData = rs.rawdata.slice()
            otherData.splice(spliceOut,1);
            output.push(...otherData);
            return output;

          })].sort((rowA,rowB)=>{
            if(!rowA[0] && !rowB[0]){
              return 0;
            }
            if(!rowA[0]){
              return 1;
            }
            if(!rowB[0]){
              return -1;
            }
            
            let dateA = dayjs(`${rowA[0]} ${rowA[3]}`,"YYYY-MM-DD HH[:]mm[hrs]").unix();
            let dateB = dayjs(`${rowB[0]} ${rowB[3]}`,"YYYY-MM-DD HH[:]mm[hrs]").unix();
            return dateA - dateB;
          })

    },
    exportXLSXautowidth(aoa){
      let autowidth = Array(aoa[0][0].length);
        for(let i=0; i< aoa.length; i++){
          for(let j=0;j < aoa[i].length; j++){
            let strlen = String(aoa[i][j]).length;
            if(!autowidth[j]){
              autowidth[j] = strlen;
              continue;
            }
            if(strlen > autowidth[j]){
              autowidth[j] = strlen;
            }
          }
        }
      return autowidth.map(wch=>{
        return {wch}
      });
    },
    toFormattedReportingTime(_v,_k,i){
      let v = i.startTime
      if(!v){
        return "";
      }
      
      return dayjs().startOf("day").add(v, "minutes").subtract(30 + v%10 ,"minutes").format("HH:mm") + "hrs";

    },
    toFormattedTime(v) {
      if(!v){
        return "";
      }
      return dayjs().startOf("day").add(v, "minutes").format("HH:mm") + "hrs";
    },
    listViewExaminer(ex_id){
      if(ex_id =="Unassigned Students"){
        return this.students.filter(s=>!s.assignment).map(s=>{
          return {
            studentName: s.name,
            instrument:s.instrument,
            grade :s.grade,
            rawdata:s.rawdata
          }
        });
      }
      let roomSlotsDetails = this.roomSlots
        .map((rs) => {
          let ra = this.getRoomAssignment(rs.raId);
          let room = this.getRoom(rs.roomId);
          let raRoom = ra.rooms.find((rm) => rm.id == rs.roomId);
          return {
            id: rs.id,
            startTime: rs.startTime,
            endTime: rs.endTime,
            date: ra.date,
            roomName: room.name,
            roomId: rs.roomId,
            raId: rs.raId,
            examiners: raRoom.examiner,
            studentId: rs.student.id,
            studentName: rs.student.name,
            grade: rs.student.grade,
            instrument: rs.student.instrument,
            rawdata:rs.student.rawdata
          };
        })
        .filter((rs) => rs.examiners.includes(ex_id));
        return roomSlotsDetails;

    },
    listViewDate(date) {
      if(!date){
        date = this.viewDate;
      }
      
      if (!date) {
        return [];
      }

      if(date =="Unassigned Students"){
        return this.students.filter(s=>!s.assignment).map(s=>{
          return {
            studentName: s.name,
            instrument:s.instrument,
            grade :s.grade,
            rawdata:s.rawdata
          }
        });
      }

      let roomSlotsDetails = this.roomSlots
        .map((rs) => {
          let ra = this.getRoomAssignment(rs.raId);
          let room = this.getRoom(rs.roomId);
          let raRoom = ra.rooms.find((rm) => rm.id == rs.roomId);
          return {
            id: rs.id,
            startTime: rs.startTime,
            endTime: rs.endTime,
            date: ra.date,
            roomName: room.name,
            roomId: rs.roomId,
            raId: rs.raId,
            examiners: raRoom.examiner,
            studentId: rs.student.id,
            studentName: rs.student.name,
            grade: rs.student.grade,
            instrument: rs.student.instrument,
            rawdata:rs.student.rawdata
          };
        })
        .filter((rs) => rs.date == date);

      return roomSlotsDetails;
    },
    removeRoomAssignment(raID) {
      let r = confirm("Remove this date? This cannot be undone");
      if (!r) {
        return;
      }
      let raDex = this.roomAssignment.findIndex((a) => a.id == raID);
      this.roomAssignment.splice(raDex, 1);
    },
    reassignExaminer(roomAssignment, examiner) {
      this.reassignModalData = {
        roomAssignment,
        examiner,
      };
      this.reassignModal = true;
    },
    adjustRoom(roomAssignment, room_id) {
      this.roomModalData = {
        roomAssignment,
        room_id,
      };
      this.roomModal = true;
    },
    getExaminer(id) {
      if(!Array.isArray(id)){
        return this.examiners.find((ex) => ex.id == id) || {};
      }
      let examiners = {
          name: "",
          instruments: [],
          instrumentLevelLimit: [],
          instrumentLevelLowerLimit:[],
          canCipp: (id.length >1)
        };
      for(let idi of id){
        let examiner = this.examiners.find((ex) => ex.id == idi);
        if(examiners.name){
          examiners.name += ", "+examiner.name
        }else{
          examiners.name = examiner.name;
        }
        examiners.instruments.push(...examiner.instruments);
        examiners.instrumentLevelLimit.push(...examiner.instrumentLevelLimit);
        examiners.instrumentLevelLowerLimit.push(...examiner.instrumentLevelLowerLimit);
      }

      return examiners
    },
    getRoom(id) {
      return this.rooms.find((rm) => rm.id == id) || {};
    },
    getRoomAssignment(id) {
      return this.roomAssignment.find((ra) => ra.id == id) || {};
    },
    getRoomAssignmentInfo(ra, id) {
      if (typeof ra == "string") {
        ra = this.getRoomAssignment(ra);
      }
      if (!ra) {
        return { not_in_use: true, examiner: [] };
      }
      return (
        ra.rooms.find((r) => r.id === id) || { not_in_use: true, examiner: [] }
      );
    },
    addOff(...input) {
      for (let i = 0; i < input.length; i++) {
        if (Array.isArray(input[i])) {
          let arr = input[i];
          let pushed = "";
          if (
            typeof input[i + 1] == "string" ||
            typeof input[i + 1] == "number"
          ) {
            pushed = input[i + 1];
          }
          arr.push(pushed);
        }
      }
    },
    addRoom() {
      this.rooms.push({ id: v4(), name: "", exclude: [] });
    },
    addExaminer() {
      this.examiners.push({
        id: v4(),
        name: "",
        instruments: [],
        instrumentLevelLimit: [],
        instrumentLevelLowerLimit:[],
        exclude: [],
      });
    },
    addRoomAssignment() {
      let date = this.addRADate;
      if (!date) {
        alert("Please specify a date");
        return;
      }
      this.addRADate = "";
      let existingRA = this.roomAssignment.find((a) => a.date == date);
      if (existingRA) {
        alert("Date has already been added");
        return;
      }
      let examinerCheck = {};
      let unavailable = [];
      //.sort() // to do - sort by number of instruments they can examine
      for (let examiner of this.examiners.slice()) {
        examinerCheck[examiner.id] = examiner.exclude.includes(date); //skip if unavailable
        if (examinerCheck[examiner.id]) {
          unavailable.push(examiner.id);
        }
      }
      this.roomAssignment.push({
        id: v4(),
        date,
        rooms: this.rooms
          .filter((rm) => !rm.exclude.includes(date))
          .map((r) => {
            return {
              id: r.id,
              examiner: [],
            };
          }),
        unassigned: Object.keys(examinerCheck).filter(
          (ex_id) => !examinerCheck[ex_id]
        ),
        unavailable,
        timeStartEndArr: this.timeStartEndArr.slice(),
      });
    },
    trimOffInput(arr, i, nocheck = false) {

      if (i + 1 == arr.length && !nocheck) {
        return;
      }
      if (arr[i] === "" || nocheck) {
        arr.splice(i, 1);
      }
    },
    getCount(instrument, grade = null, assignedOnly = false) {
      let i = 0;
      for (let student of this.students) {
        if (
          (student.grade === grade || grade === null) &&
          student.instrument === instrument &&
          (!assignedOnly || student.assignment !== null)
        ) {
          i++;
        }
      }
      return i;
    },
    generateData() {
      let arr = new Array(200);
      for (let i = 0; i < arr.length; i++) {
        arr[i] = {
          id: v4(),
          name: rndName.generate(),
          grade: rndArr(grades),
          instrument: rndArr(instruments),
          assignment: null,
        };
      }

      this.students = arr;
    },
    generateDuration() {
      let output = new Array(instruments.length);
      for (let i = 0; i < output.length; i++) {
        output[i] = [6, 8, 10, 14, 18, 18, 25, 25, 30];
      }
      this.duration = output;

      return output;
    },
    runRoomAssignment() {
      let ra = (this.roomAssignment = []);
      let endDate = dayjs(this.end).endOf("day");
      let currentDate = dayjs(this.start).startOf("day");
      let examinerUsage = {};
      for (let examiner of this.examiners) {
        examinerUsage[examiner.id] = 0;
      }
      
      while (currentDate.isBefore(endDate)) {
        let date = currentDate.format("YYYY-MM-DD");
        let oldCurrentDate = currentDate;
        currentDate = currentDate.add(1, "day");
        if (!this.assignableDays.includes(oldCurrentDate.day())) {
          continue;
        }
        if (this.offDays.includes(date)) {
          continue;
        }

        let examinerCheck = {};
        let unavailable = [];
        //.sort() // to do - sort by number of instruments they can examine
        for (let examiner of this.examiners
          .slice()
          .sort((a, b) => examinerUsage[a.id] - examinerUsage[b.id])) {
          //sort by usage (fewer sessions, more deployment)
          examinerCheck[examiner.id] = examiner.exclude.includes(date); //skip if unavailable
          if (examinerCheck[examiner.id]) {
            unavailable.push(examiner.id);
          }
        }

        ra.push({
          id: v4(),
          date,
          rooms: this.rooms
            .filter((rm) => !rm.exclude.includes(date))
            .map((r) => {
              let examiner = [];
              for (let ex_id in examinerCheck) {
                if (examinerCheck[ex_id]) {
                  continue;
                }

                examinerCheck[ex_id] = true;
                examiner = [ex_id];
                examinerUsage[ex_id]++;
                break;
              }
              return {
                id: r.id,
                examiner,
              };
            }),
          unassigned: Object.keys(examinerCheck).filter(
            (ex_id) => !examinerCheck[ex_id]
          ),
          unavailable,
          timeStartEndArr: this.timeStartEndArr.slice(),
        });
      }
    },
    getEarliestTimeSlot(raId, roomId, duration,timeStartEndArr) {
      let markers = [];
      for(let session of timeStartEndArr){
          for(let time of session){
            let arr = time.split(":").map(hhmm=>Number(hhmm));
            markers.push(arr[0]*60+arr[1]);
          }
          
      }

      let startMarker = { endTime: markers[0]};
      let endMarker = { startTime: markers[markers.length-1]}
      let breakMarker = [];

      for(let i=1;i < (markers.length-1 ); i+=2){
        breakMarker.push({startTime: markers[i], endTime:markers[i+1] });
      }

      let takenSlots = [
        startMarker,
        ...[...this.roomSlots
            .filter((rs) => rs.roomId == roomId && rs.raId == raId),
            ...breakMarker
          ]
        .sort((a, b) => a.startTime - b.startTime),
        endMarker,
      ];

      for (let i = -1; i < takenSlots.length; i++) {
        let slot1 = takenSlots[i] || { endTime: 9 * 60 };
        let slot2 = takenSlots[i + 1] || { startTime: 18 * 60 };
        let diff = slot2.startTime - slot1.endTime || 0;
        if (diff >= duration) {
          return slot1.endTime;
        }
      }
      console.log("noroom");
      return false;
    },
    autoAssign(firstRound=false) {
      let cipp = (this.cippfirst && !firstRound) || (firstRound && !this.cippfirst);
      if(!firstRound){
        this.roomSlots = []; //reset all Data;
        for(let student of this.students){
          student.assignment = null;
        }
      }
      //roomAssignmentLoop:
      for (let ra of this.roomAssignmentSorted) {
        //roomLoop:
        for (let room of ra.rooms) {

          let examiner = this.getExaminer(room.examiner);
          if(cipp && !examiner.canCipp){
            console.log("room cannot cipp")
            continue;
          }
          //studentLoop:
          let students = this.students.sort((s1,s2)=>this.cippfirst ? (s2.grade - s1.grade) : (s1.grade - s2.grade));
          for (let student of students) {
            //console.log("student",student.id);
            if (student.assignment) {
              continue;
            }
            //skip CIPP for now
            if(!cipp && student.grade ==8){
              continue;
            }
            //dont assign if its the CIPP round
            if(cipp && student.grade !=8){
              continue;
            }
            let duration = Number(this.duration[student.instrument][student.grade]);
            let earliestTimeSlot = this.getEarliestTimeSlot(
              ra.id,
              room.id,
              duration,
              ra.timeStartEndArr
            );
            if (!earliestTimeSlot) {
              continue;
            }

            //instLoop:
            for (let i=0; i< examiner.instruments.length; i++) {
              let inst = examiner.instruments[i];
              let instLevelLimit = examiner.instrumentLevelLimit[i];
              let instLevelLowerLimit = examiner.instrumentLevelLowerLimit[i]
              
              if (
                student.instrument == inst && 
                instLevelLimit >= student.grade &&
                instLevelLowerLimit <= student.grade 

              ) {
                //can assign
                let roomslotId = v4();
                student.assignment = roomslotId;
                this.roomSlots.push({
                  id: roomslotId,
                  roomId: room.id,
                  raId: ra.id,
                  startTime: earliestTimeSlot,
                  endTime: earliestTimeSlot + duration,
                  student,
                });
                //console.log("assignedStudent", student.id);

                break;
              }
            }
          }
        }
      }
      if(!firstRound){
        this.autoAssign(true);
      }else{
        let unassigned = 0;
        let assigned = 0;
        for(let student of this.students){
          if(!student.assignment){
            unassigned++
          }else{
            assigned++
          }
        }
        let msg =`${assigned} Slots automatically assigned!`;
        if(unassigned >0){
          msg += `\n${unassigned} students could not be assigned a slot`
        }
        alert(msg);

      }
      
      
    },
  },
  computed: {
    dayjs(){
      return dayjs;
    },
    assignmentTableData() {
      return this.listViewDate();
    },
    assignmentTableFields() {
      return [
        { key: "studentName" },
        { key: "roomName", sortable: true },
        { key: "reportingTime", formatter:this.toFormattedReportingTime, sortable: true },
        { key: "startTime", formatter: this.toFormattedTime, sortable: true },
        { key: "endTime", formatter: this.toFormattedTime, sortable: true },
        { key: "instrument", formatter: (inst) => instruments[inst] },
        { key: "grade", formatter: (grd) => grades[grd] },
        { key: "examiners" },
      ];
    },
    roomAssignmentSorted() {
      return this.roomAssignment
        .slice()
        .sort((a, b) => a.date.localeCompare(b.date));
    },
    roomModalUnavailable: {
      get() {
        if (!this.roomModal) {
          return null;
        }
        let ra = this.getRoomAssignment(this.roomModalData.roomAssignment);
        let room = ra.rooms.find((rm) => rm.id == this.roomModalData.room_id);
        if (room) {
          return false;
        }
        return true;
      },
      set(v) {
        if (!this.roomModal) {
          return;
        }
        let ra = this.getRoomAssignment(this.roomModalData.roomAssignment);
        let roomDex = ra.rooms.findIndex(
          (rm) => rm.id == this.roomModalData.room_id
        );
        let roomDetails = this.getRoom(this.roomModalData.room_id);
        if (v && roomDetails) {
          roomDetails.exclude.push(ra.date);
        }
        if (v && roomDex > -1) {
          ra.rooms.splice(roomDex, 1);
        }
        if (!v) {
          ra.rooms.push({
            examiner: [],
            id: this.roomModalData.room_id,
          });
          if (roomDetails) {
            let dateIndex = roomDetails.exclude.indexOf(ra.date);
            roomDetails.exclude.splice(dateIndex, 1);
          }
        }
      },
    },
    reassignModalRoom: {
      get() {
        if (!this.reassignModal) {
          return null;
        }
        let ra = this.getRoomAssignment(this.reassignModalData.roomAssignment);
        let room = ra.rooms.find((rm) =>
          rm.examiner.includes(this.reassignModalData.examiner)
        );
        if (room) {
          return room.id;
        }
        if (ra.unassigned.includes(this.reassignModalData.examiner)) {
          return "unassigned";
        }
        if (ra.unavailable.includes(this.reassignModalData.examiner)) {
          return "unavailable";
        }
        return null;
      },
      set(room_id) {
        if (!this.reassignModal) {
          return;
        }
        let ra = this.getRoomAssignment(this.reassignModalData.roomAssignment);

        //remove examiner from current room
        let currentRoom = ra.rooms.find((rm) =>
          rm.examiner.includes(this.reassignModalData.examiner)
        );
        if (currentRoom) {
          currentRoom.examiner.splice(
            currentRoom.examiner.indexOf(this.reassignModalData.examiner),
            1
          );
        } else {
          if (ra.unassigned.includes(this.reassignModalData.examiner)) {
            ra.unassigned.splice(
              ra.unassigned.indexOf(this.reassignModalData.examiner),
              1
            );
          }
          if (ra.unavailable.includes(this.reassignModalData.examiner)) {
            ra.unavailable.splice(
              ra.unavailable.indexOf(this.reassignModalData.examiner),
              1
            );
          }
        }

        if (room_id == "unassigned") {
          ra.unassigned.push(this.reassignModalData.examiner);
          return;
        }
        if (room_id == "unavailable") {
          ra.unavailable.push(this.reassignModalData.examiner);
          return;
        }

        //add examiner to new room
        let room = ra.rooms.find((rm) => rm.id == room_id);
        room.examiner.push(this.reassignModalData.examiner);
      },
    },
    reassignModalTitle() {
      return `${
        this.getExaminer(this.reassignModalData.examiner).name
      }  - ${dayjs(
        this.getRoomAssignment(this.reassignModalData.roomAssignment).date
      ).format("ddd, DD MMM YYYY")}`;
    },
    roomModalTitle() {
      return `${this.getRoom(this.roomModalData.room_id).name}  - ${dayjs(
        this.getRoomAssignment(this.roomModalData.roomAssignment).date
      ).format("ddd, DD MMM YYYY")}`;
    },

    assignmentDateDropdown() {
      return [
        { value: null, text: "Pick a Date" },
        { value: "Unassigned Students", text: "Unassigned Students" },

        ...this.roomAssignmentSorted.map((ra) => {
          return {
            value: ra.date,
            text: dayjs(ra.date).format("ddd, DD MMM YYYY "),
          };
        }),
      ];
    },
    instrumentDropDown() {
      let output = [];
      for (let i = 0; i < instruments.length; i++) {
        output.push({
          text: instruments[i],
          value: i,
        });
      }
      return output;
    },
    instrumentGradeDropDown() {
      let output = [];
      for (let i = 0; i < grades.length; i++) {
        output.push({
          text: grades[i],
          value: i,
        });
      }
      return output;
    },
    instGradeMatrix() {
      let output = [];
      for (let i = 0; i < instruments.length; i++) {
        let row = {
          Instrument: instruments[i],
        };
        row.totalSlots = `${this.getCount(i, null, true)} / ${this.getCount(
          i
        )}`;

        for (let j = 0; j < grades.length; j++) {
          row[grades[j]] = `${this.getCount(i, j, true)} / ${this.getCount(
            i,
            j
          )}`;
        }
        output.push(row);
      }
      return output;
    },
    instGradeFields() {
      let arr = [{ key: "Instrument", stickyColumn: true, isRowHeader: true }];
      arr.push({
        key: "totalSlots",
        stickyColumn: true,
        tdClass: "font-weight-bold",
        variant: "primary",
      });

      if (!this.byInstrument) {
        for (let j = 0; j < grades.length; j++) {
          arr.push(grades[j]);
        }
      }
      return arr;
    },
  },
  watch:{
    noOfSessions(v){
      let x = this.timeStartEndArr.length;
      if(v>x){
        this.timeStartEndArr.push(Array(v-x).fill(["",""]))
      }
      if(v<x){
        this.timeStartEndArr.splice(v-x,x-v);

      }
      
    }
  }
};
</script>
